import { useState, useEffect, useContext } from "react";
import Select from "react-select";
import RemoveIcon from "../../../assets/removeIcon.svg";
import { Formik, Form, Field } from "formik";
import { number, object, string, date } from "yup";
import { CaseServices } from "../../../services/CaseServices";
import { useDispatch } from "react-redux";
import { selectedTab } from "../../../redux/roleSlice";
import { CaseContext } from "../contexts/CaseContexts";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
const errorValidation = object({
  days: number().required("Required Field"),
  fromDate: date().required("Required Field"),
  toDate: date().required("Required Field"),
  ward: string().required("Required Field"),
  procedureId: string().required("Please select procedure"),
});
const AddEnhancementForm = ({
  daysOptions,
  wardOptions,
  caseProcedures,
  totalPackageCost,
  setAddEnhancement,
  caseId,
  startDate,
  initialStartDate,
  enhancementNumber,
  setValue,
  caseDetails,
  type = "Add",
  enhancementDetails,
  getEnhancementList,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [tierCost, setTierCost] = useState([]);
  const { refreshFunction } = useContext(CaseContext);
  const dispatch = useDispatch();

  const initialValues =
    type === "Edit"
      ? {
          days: enhancementDetails?.details?.enhancementDays,
          fromDate: enhancementDetails?.details?.fromDate?.slice(0, 10),
          toDate: enhancementDetails?.details?.toDate?.slice(0, 10),
          ward: enhancementDetails?.details?.wardType,
          price: enhancementDetails?.details?.enhancementPerDayCost,
          procedureId: enhancementDetails?.details?.procedureId,
        }
      : {
          days: "",
          fromDate: "",
          toDate: "",
          ward: "",
          price: "",
          procedureId: "",
        };

  // allow today + up to 4 days in future
  const futureLimit = new Date();
  futureLimit.setDate(futureLimit.getDate() + 4);
  const futureLimitStr = futureLimit.toISOString().split("T")[0];
  const maxDate = caseDetails?.submasterstagestatuses[0]?.commandCenterStage
    .toLowerCase()
    .includes("request to add new enhancement procedure")
    ? futureLimitStr
    : new Date().toISOString().split("T")[0];

  const handleDaysChange = (item, setFieldValue, values) => {
    setFieldValue("days", item.value);
    if (values["fromDate"]) {
      const toDate = new Date(values["fromDate"]);
      toDate.setDate(
        new Date(values["fromDate"]).getDate() + Number(item.value) - 1
      );
      setFieldValue("toDate", toDate.toISOString().split("T")[0]);
    }
  };
  const handleDateChange = (e, setFieldValue, values) => {
    {
      const toDate = new Date(e.target.value);
      toDate.setDate(
        new Date(e.target.value).getDate() + Number(values["days"]) - 1
      );

      setFieldValue("fromDate", e.target.value);
      setFieldValue("toDate", toDate.toISOString().split("T")[0]);
    }
  };
  const getProcedureCostList = async (procedureId) => {
    const selectedProcedure = caseDetails?.caseprocedures?.filter(
      (procedure) => procedure?.id === procedureId
    );
    try {
      const response = await CaseServices.getProcedureCostList(
        selectedProcedure[0]?.compositId,
        caseDetails?.patient?.city
      );
      console.log("response procedure cost list:", response.data);
      if (response?.data?.procedureCost?.tierCost) {
        setTierCost(response?.data?.procedureCost?.tierCost);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    const data =
      type === "Edit"
        ? [
            {
              id: enhancementDetails?.id,
              detailType: "ENHANCEMENT",
              caseId: caseId,
              details: {
                procedureId: values.procedureId,
                enhancementDate: enhancementDetails?.details?.enhancementDate,
                fromDate: values.fromDate,
                toDate: values.toDate,
                wardType: values.ward,
                enhancementDays: values.days,
                cost: Number(values.price) * Number(values.days),
                enhancementPerDayCost: Number(values.price),
              },
              status: 1,
              version: 0,
            },
          ]
        : [
            {
              detailType: "ENHANCEMENT",
              caseId: caseId,
              details: {
                procedureId: values.procedureId,
                enhancementDate: new Date(),
                fromDate: values.fromDate,
                toDate: values.toDate,
                wardType: values.ward,
                enhancementDays: values.days,
                cost: Number(values.price) * Number(values.days),
                enhancementPerDayCost: Number(values.price),
              },
              status: 1,
              version: 0,
            },
          ];
    if (isChanged) {
      try {
        const res = await CaseServices.addEnhancement(data);
        dispatch(selectedTab(null));
        type === "Add" ? setValue("MAP DOCUMENTS") : await getEnhancementList();
        if (type === "Edit") {
          window.alert(res?.data?.message);
          setAddEnhancement(false);
        }
        await refreshFunction();
      } catch (error) {
        if (error?.response?.status === 420) {
          window.alert(
            "Enhancement documents are not yet mapped. Please perform Initiate Enhancement process when documents are mapped."
          );
        } else {
          handleApiErrorResponses(error);
        }
      }
    }
    setIsSubmitting(false);
  };
  useEffect(() => {
    if (enhancementDetails?.details?.procedureId) {
      getProcedureCostList(enhancementDetails?.details?.procedureId);
    }
  }, []);
  console.log("tier cost:", tierCost);
  console.log(
    "stage",
    caseDetails?.submasterstagestatuses[0]?.commandCenterStage
  );
  console.log("tier cost length:", tierCost.length);
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={errorValidation}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, setFieldValue, values }) => (
        <Form>
          {type === "Add" && (
            <div className="flex justify-between">
              <div className="font-semibold text-[#191919]">
                Enhancement {enhancementNumber}
              </div>

              <div
                className="cursor-pointer"
                onClick={() => setAddEnhancement(false)}
              >
                <img src={RemoveIcon} alt="remove-icon" />
              </div>
            </div>
          )}
          <div className="flex justify-between flex-wrap gap-y-8  mt-8">
            <div className="w-full xl:w-[48%]">
              <div className="text-sm text-[#191919] font-medium mb-4">
                1. Please Select Procedure
              </div>
              <Select
                name="procedureId"
                placeholder="Select Procedure"
                options={caseProcedures}
                getOptionLabel={(options) => {
                  return options["procedure"];
                }}
                getOptionValue={(options) => {
                  return options["id"];
                }}
                value={caseProcedures?.filter(
                  (option) => option.id === values.procedureId
                )}
                onChange={(item) => {
                  setFieldValue("procedureId", item.id);
                  setFieldValue("ward", ""); //resetting the value upon selecting different procedure
                  setFieldValue("price", "");
                  setIsChanged(true);
                  getProcedureCostList(item.id);
                }}
              />
              {touched.procedureId && errors.procedureId && (
                <div className="field-error">{errors.procedureId}</div>
              )}
            </div>
            <div className="w-full xl:w-[48%]">
              <div className="text-sm text-[#191919] font-medium mb-4">
                2. In which ward would you like to take the enhancement?
              </div>
              {(Array.isArray(tierCost) ||
                caseDetails?.submasterstagestatuses[0]?.commandCenterStage
                  .toLowerCase()
                  .includes("request to add new enhancement procedure")) && (
                <Select
                  name="ward"
                  placeholder="Select Ward"
                  options={
                    Array.isArray(tierCost) && tierCost.length
                      ? tierCost
                      : wardOptions
                  }
                  // options={tierCost ? tierCost : wardOptions}
                  getOptionLabel={(options) => options["name"]}
                  getOptionValue={(options) => options["price"]}
                  // value={tierCost?.filter((cost) => cost.name === values.ward)}
                  onChange={(item) => {
                    setIsChanged(true);
                    setFieldValue("ward", item.name);
                    setFieldValue("price", item.price || 0);
                  }}
                />
              )}
              {!Array.isArray(tierCost) &&
                !caseDetails?.submasterstagestatuses[0]?.commandCenterStage
                  .toLowerCase()
                  .includes("request to add new enhancement procedure") && (
                  <div className="field-error pt-1">
                    * Selected Procedure does not have any stratifications.
                  </div>
                )}
              {touched.ward && errors.ward && (
                <div className="field-error">{errors.ward}</div>
              )}
            </div>
            <div className="w-full xl:w-[48%]">
              <div className="text-sm text-[#191919] font-medium mb-4">
                3. For how many days would you like to initiate the enhancement?
              </div>

              <Select
                name="days"
                placeholder="Select Days"
                options={
                  caseDetails?.hospital?.tmsVersion === "1.0"
                    ? daysOptions?.primary
                    : values.ward?.toLowerCase().includes("ventilator")
                    ? daysOptions?.secondary
                    : daysOptions?.tertiary
                }
                value={daysOptions?.tertiary?.filter(
                  (day) => day.value == values.days
                )}
                onChange={(item) => {
                  setIsChanged(true);
                  handleDaysChange(item, setFieldValue, values);
                }}
              />
              {touched.days && errors.days && (
                <div className="field-error">{errors.days}</div>
              )}
            </div>
            <div className="w-full xl:w-[48%]">
              <div className="text-sm text-[#191919] font-medium mb-4">
                4. From which date to which date should the enhancement last?
              </div>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <Field
                    type="date"
                    name="fromDate"
                    placeholder="--/--/---"
                    // min={
                    //   new Date(
                    //     new Date(
                    //       caseDetails?.submasterstagestatuses[0]?.commandCenterStage
                    //         .toLowerCase()
                    //         .includes("enhancement rejected")
                    //         ? initialStartDate
                    //         : startDate
                    //     ).setDate(
                    //       caseDetails?.submasterstagestatuses[0]?.commandCenterStage
                    //         .toLowerCase()
                    //         .includes("enhancement rejected")
                    //         ? new Date(initialStartDate).getDate()
                    //         : caseDetails?.submasterstagestatuses[0]?.commandCenterStage
                    //             .toLowerCase()
                    //             .includes(
                    //               "request to add new enhancement procedure"
                    //             )
                    //         ? new Date(startDate).getDate()
                    //         : new Date(startDate).getDate() + 1
                    //     )
                    //   )
                    //     .toISOString()
                    //     .split("T")[0]
                    // }
                    min={
                      new Date(
                        new Date(
                          (() => {
                            const stage =
                              caseDetails?.submasterstagestatuses[0]?.commandCenterStage?.toLowerCase() ||
                              "";

                            return stage.includes("enhancement rejected")
                              ? initialStartDate
                              : startDate;
                          })()
                        ).setDate(
                          (() => {
                            const stage =
                              caseDetails?.submasterstagestatuses[0]?.commandCenterStage?.toLowerCase() ||
                              "";

                            if (stage.includes("enhancement rejected")) {
                              return new Date(initialStartDate).getDate();
                            }
                            if (
                              stage.includes(
                                "request to add new enhancement procedure"
                              )
                            ) {
                              return new Date(startDate).getDate();
                            }
                            return new Date(startDate).getDate() + 1;
                          })()
                        )
                      )
                        .toISOString()
                        .split("T")[0]
                    }
                    max={maxDate}
                    style={{ border: "1px solid #E4E4E4", width: "100%" }}
                    className="rounded-[8px] py-[10px] px-2"
                    onChange={(e) => {
                      handleDateChange(e, setFieldValue, values);
                      setIsChanged(true);
                    }}
                  />
                  {touched.fromDate && errors.fromDate && (
                    <div className="field-error">{errors.fromDate}</div>
                  )}
                </div>

                <div>
                  <Field
                    type="date"
                    name="toDate"
                    placeholder="--/--/---"
                    disabled
                    style={{ border: "1px solid #E4E4E4", width: "100%" }}
                    className="rounded-[8px] py-[10px] px-2"
                  />
                  {touched.toDate && errors.toDate && (
                    <div className="field-error">{errors.toDate}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            {isSubmitting ? (
              <CircularProgress />
            ) : (
              <button
                type="submit"
                style={{ border: "1px solid #017C57" }}
                className="w-fit text-[#017C57] font-semibold bg-white rounded-full mt-12 px-4 py-2 border-0 cursor-pointer uppercase"
              >
                SAVE DETAILS
              </button>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddEnhancementForm;
